export default __webpack_public_path__ + "static/media/martin_speedy.1e30b0a0.jpg";